import {
  Button,
  Input,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Checkbox,
  ListItemText,
  Modal,
  Box,
  Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./ManageAccess.css";
import { useDispatch, useSelector } from "react-redux";
import { addAdminUser } from "../Redux/AdminUserSlice";
import { Label } from "@mui/icons-material";
const ManageAccess = () => {
  const [selectedroles, setSelectedRoles] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [userName, setUsername] = useState("");
  const [message, setMessage] = useState("");
  const userStatus =
    useSelector((state) => state?.adminUser?.isUserExists?.payload) ?? false;
  const [modalOpen, setModalOpen] = React.useState(false);
  //   const handleOpen = () => setOpen(true);
  const [status, setStatus] = useState(false);
  console.log("status", userStatus);

  const handleModalClose = () => setModalOpen(false);
  useEffect(() => {
    if (userStatus && userStatus != undefined) {
      setStatus(true);
    }
  }, [userStatus]);

  console.log("status", userStatus);
  const dispatch = useDispatch();
  const definedRoles = ["Requestor", "TH"];
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRoles([]);
    } else {
      setSelectedRoles(definedRoles);
    }
    setSelectAll(!selectAll);
  };
  const submitFormHandler = (e) => {
    e.preventDefault();
  };
  const addUserHandler = () => {
    // const formData = new FormData()
    console.log("userName, selectedroles", userName, selectedroles);
    // formData.append( userName, selectedroles)
    if (userName !== "" && selectedroles !== "") {
      dispatch(addAdminUser(userName, selectedroles));
      setUsername("");
      setSelectedRoles("");
    } else {
      setMessage("Please select Required Fields!");
    }
  };
  return (
    <div id="manage-access">
      <div className="addUserLable">Add User</div>
      <div className="form-status">
        {status && userStatus && userStatus != undefined && (
          <Alert severity="success" onClose={() => setStatus(false)}>
            {userStatus}
          </Alert>
        )}
        {!userStatus && message.length > 0 && (
          <Alert severity="warning" onClose={() => setMessage(false)}>
            {message}
          </Alert>
        )}
      </div>
      <div className="user-container">
        <FormControl
          fullWidth
          onSubmit={submitFormHandler}
          className="form-container"
        >
          <div className="username element">
            <span className="lable">
              <span className="required-field">*</span>Enterprise ID:
            </span>
            <Input
              id="enterpriseid"
              className="right-element"
              type="text"
              onChange={(e) => setUsername(e.target.value)}
              value={userName}
              autoComplete="off"
              placeholder="Enter Enterprise iD"
              required
            />
          </div>
          <span className="user-instruction">(Please add Enterprise ID in <strong>abc.xyz</strong> format.)</span>
          <FormControl className="selectionSelection element">
            <span className="lable">
              <span className="required-field">*</span>Select Role:
            </span>
            <Select
              multiple
              id="select-section right"
              // label="Select Section"
              className="select-dropdown right-element"
              value={selectedroles || []}
              onChange={(e) => setSelectedRoles(e.target.value)}
              renderValue={(selected) => selected.join(", ")}
            >
              <MenuItem value="selectAll">
                <Checkbox checked={selectAll} onChange={handleSelectAll} />
                <ListItemText primary="Select All" />
              </MenuItem>
              {definedRoles.map((option) => (
                <MenuItem key={option} value={option}>
                  <Checkbox checked={selectedroles.indexOf(option) > -1} />
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className="form-submit">
            <Button
              className="submit-btn"
              type="submit"
              variant="contained"
              onClick={addUserHandler}
            >
              Add
            </Button>
          </div>
        </FormControl>
      </div>
    </div>
  );
};

export default ManageAccess;
